/**
 * @file
 * Link script.
 */

(function linkScript($, Drupal, _) {
  'use strict';

  Drupal.behaviors.links = {
    attach: function targetBlankAccessible(context) {
      $('a[target="_blank"]').each(function () {
        if (!$(this).hasClass('social-links__link') && !$(this).parent().hasClass('menu__item')) {
          $(this).addClass('a-link--external');
          $(this).append('<span class="visually-hidden">(opens in a new window)</span>');
        }
      });
    }
  };
}(jQuery, Drupal, _));
